import Highway from '@dogstudio/highway'

import modular from 'modujs'
import * as modules from './modules'
import ColorTimeline from './modules/ColorTimeline'
import CustomCursor from './modules/CustomCursor'
import FadeTransition from './modules/FadeTransition'
import Scroller from './modules/Scroller'
import { initPrefetch, refreshPrefetch } from './utils/prefetch'
import { prepareProjectPage, injectVideoPreconnects } from './utils/projectVideoHints'
import { initProjectPagePrefetch } from './utils/projectPagePrefetch'
import { classesInjection, rewriteLinks } from './utils/transitions'


const Modular = modular
const app = new Modular({
  modules
})



class DefaultRenderer extends Highway.Renderer {
  onEnterCompleted () {
    const view = this.wrap?.lastElementChild ?? document.querySelector('[data-router-view]')

    void (async () => {
      await prepareProjectPage(view, window.themeAssets)
      rewriteLinks()
      refreshPrefetch()
      app.init(app)
      ColorTimeline.updateThemeColor()
    })()

    return this
  }

  onLeaveCompleted () {
    app.destroy()
    return this
  }
}

const init = () => {
  classesInjection()
  new Scroller()

  
  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer
    },
    transitions: {
      default: FadeTransition
    }
  })

  H.on('NAVIGATE_IN', ({ to, trigger }) => {
    app.destroy()
    window.lenis.start()

    const player = to?.view?.querySelector?.('[data-module-player]')
    if (player) {
      injectVideoPreconnects(player.dataset.provider, window.themeAssets?.videoPreconnects)
    }

    if (trigger !== 'popstate') {
      window.lenis.scrollTo(0, {
        lock: true,
        immediate: true
      })
    }
  })

  window.H = H
  new CustomCursor()
  initPrefetch()
  initProjectPagePrefetch()
}

document.addEventListener('DOMContentLoaded', init)
